import React from "react";

interface ToastNotificationProps {
  message: string | null;
  type?: "success" | "error";
}

export const ToastNotification: React.FC<ToastNotificationProps> = ({
  message,
  type = "success",
}) => {
  if (!message) return null;
  const isSuccess = type === "success";

  return (
    <div
      className={`flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg bg-[var(--bg-elevated)] border border-[var(--border-subtle)] border-l-4 text-[13px] font-medium text-[var(--text-primary)] transition-all duration-300 ${isSuccess ? "border-l-[var(--status-success)]" : "border-l-[var(--status-error)]"}`}
    >
      {type === "success" ? (
        <svg
          className="w-4 h-4 text-[var(--status-success)]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      ) : (
        <svg
          className="w-4 h-4 text-[var(--status-error)]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      )}
      {message}
    </div>
  );
};
